import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

const EXTERNAL_SCHEMES = ['http://', 'https://', 'mailto:', 'tel:'];

export const isExternalUrl = (value: string) => {
  const v = value.trim().toLowerCase();
  return EXTERNAL_SCHEMES.some((scheme) => v.startsWith(scheme));
};

export const openExternal = async (url: string, fallbackTarget = '_blank') => {
  const trimmed = String(url || '').trim();
  if (!trimmed || !isExternalUrl(trimmed)) return;

  if (Capacitor.isNativePlatform()) {
    await Browser.open({ url: trimmed });
    return;
  }

  window.open(trimmed, fallbackTarget, 'noopener,noreferrer');
};
